"use client";

import React, { useEffect, useState } from "react";
import { Heading, Empty, Spinner } from "ui-components";

import { EventCard } from "@/src/components/events/EventCard";
import {
  useOrganizationGetOrganizationExclusiveWebinars,
  WpPostEntity,
} from "@/src/hooks/api/generated";

export function OrganizationExclusiveWebinar(): JSX.Element {
  const { mutate: getEvents, isPending } =
    useOrganizationGetOrganizationExclusiveWebinars();

  const [events, setEvents] = useState<WpPostEntity[]>([]);

  useEffect(() => {
    getEvents(
      {
        data: {
          page: 1,
          pageSize: 30,
        },
      },
      {
        onSuccess: (data) => {
          setEvents(data.data);
        },
      }
    );
  }, []);

  return (
    <div className="w-full md:w-1/5 flex flex-col gap-y-5">
      <Heading variant="h2">Exclusive Webinars</Heading>
      {isPending && (
        <div className="flex justify-center items-center">
          <Spinner />
        </div>
      )}
      {!events.length && !isPending ? (
        <Empty text="No webinars found." />
      ) : (
        <div className="h-[1000px] overflow-y-scroll space-y-5">
          {events.map((event) => (
            <EventCard key={event.ID} event={event} height={140} />
          ))}
        </div>
      )}
    </div>
  );
}
